import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import baseUrl from '../baseurl'

const _ = require('lodash')

export default {
  actions: {
    saveGeneralInfo({
      commit,
      state
    }, {
      commodity,
      data }) {

      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        Axios.post(baseUrl + `/api/${commodity.toLowerCase()}/generalinfo`, data, config)
          .then(resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
            } else {
              commit('updateGeneralInfo', data);
              commit('updateDocId', resp.data.data);
              commit('resetSavedTabs');
              commit('resetSampleData')
              resolve(resp)
            }

          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);
            reject(err)
          })
      })
    }
  },
  mutations:{

    resetSampleData(state) {
      state.sampleStateData = [{}]
      state.sampleThresholds = {}
    },
  }
}
